import Vue from 'vue'
import Vuex from 'vuex'
// import moment from 'moment'
import _apiService from './services/APIService'
// import VueRouter from 'vue-router'
// import routes from './routes'
import _storage from './services/StorageService'
import _ from "lodash";

Vue.use(Vuex)


const state = {
    myOrders: [],
    userToken: _storage.getItem('mys_token'),
    user: {
        fullname: "",
        roles: []
    },
    activeAccount: _storage.getItem("active_account"),
    activeWarehouseId: _storage.getItem("active_warehouse_id"),
    activeWarehousePrinterId: _storage.getItem("active_printer_id"),
    warehouseShipments: [],
    warehousePrinters: [],
}
const getters = {
    user(state) {
        return state.user;
    },
    activeAccount(state) {
        return state.activeAccount;
    },
    activeWarehouseId(state) {
        return state.activeWarehouseId;
    },
    activeWarehousePrinterId(state) {
        return state.activeWarehousePrinterId;
    },
    warehouses(state) {
        return _.uniqBy(state.user.roles, "warehouseId");
    },
    warehousePrinters(state) {
        return state.warehousePrinters
    },
    shops(state) {
        return _.uniqBy(state.user.roles.filter(r => r.warehouseId === state.activeWarehouseId), "mys_account");
    },
    warehouseShipments(state){
        return state.warehouseShipments;
    }
}

const actions = {
    async loadUser({commit, dispatch}) {
        const r = await _apiService.getApi(`/portals/v1/user/me`);
        commit("SET_USER", r.data);
        if(!state.activeWarehouseId)
            dispatch('setWarehouseId', r.data.roles[0].warehouseId);
        else
            dispatch('loadWarehousePrinters')
    },
    setWarehouseId({commit, dispatch}, warehouseId) {
        commit('SET_WAREHOUSEID', warehouseId);
        dispatch('loadWarehousePrinters');
    },
    async loadWarehouseShipments({state, commit}) {
        const r = await _apiService.getApi(`/portals/v1/warehouses/${state.activeWarehouseId}/shipments`);
        commit("SET_WAREHOUSESHIPMENTS", r.data);
    },
    async loadWarehousePrinters({ state, commit }) {
        commit("SET_WAREHOUSEPRINTERS", []);
        const r = await _apiService.getApi(`/portals/v1/warehouses/${state.activeWarehouseId}/printers`);
        commit("SET_WAREHOUSEPRINTERS", r.data);
        if (!state.activeWarehousePrinterId) {
            commit("SET_WAREHOUSEPRINTERID", state.warehousePrinters[0].mys_warehouseprinterid);
        }
    },
}

const mutations = {
    SET_WAREHOUSESHIPMENTS(state, shipments) {
        state.warehouseShipments = shipments;
    },
    SET_USER(state, user) {
        state.user = user;
    },
    SET_ACCOUNT(state, account) {
        if (!account)
            return;
        state.activeAccount = account;
        _storage.setItem("active_account", account);

    },
    SET_WAREHOUSEID(state, warehouseId, store) {
        state.activeWarehouseId = warehouseId;
    },
    SET_WAREHOUSEPRINTERID(state, warehousePrinterId, store) {
        state.activeWarehousePrinterId = warehousePrinterId;
        _storage.setItem("active_printer_id", warehousePrinterId);
    },
    SET_WAREHOUSEPRINTERS(state, warehousePrinters, store) {
        state.warehousePrinters = warehousePrinters
    },
    SET_TOKEN(state, token) {
        state.userToken = token;
        _storage.setItem("mys_token", token);
    }
}

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})
